module.exports = __webpack_public_path__ + "static/media/WHO_WE_HELP_1.d151692d.png";